import axios from 'axios';
import { WithAbortFn } from '../@types/external-api';
import { apiWrapper } from '../config/api-wrapper';
import environment from '../config/env';

class ReportService {
  public getReport(
    startDate: string,
    endDate: string,
    reportFormat: string,
    reportType: string,
  ): WithAbortFn<Promise<Response>> {
    const source = axios.CancelToken.source();

    return {
      promise: apiWrapper.api.get(`${environment.ADMIN_API_URL}/report/download`, {
        params: {
          start_date: startDate,
          end_date: endDate,
          feedback_report_format: reportFormat,
          feedback_report_type: reportType,
        },
        responseType: 'blob',
      }),
      abort: source.cancel,
    };
  }
}

const reportService = new ReportService();

export default reportService;
